import React, { useEffect } from 'react'
import { Modal, Select, Tabs } from '@mantine/core'
import BaseButton from '../common/BaseButton'
import List from '../common/List'
import MantineSelectBox from '../common/MantineSelectBox'
import '../../styles/admin/uploads.css'
import SaveButton from '../common/SaveButton'
import { useState } from 'react'
import PdfDropzone from '../common/PdfDropZone'
import ImageDropzone from '../common/ImageDropzone'
import BookInfoCard from './BookInfoCard'
import { useAuthStore } from '../../store'
import { apiRequest, uploadRequest } from '../../utils/api'
import { notifications } from '@mantine/notifications'
import ManualCard from '../common/ManualCard'
import { modals } from '@mantine/modals'
import { Pagination } from '@mantine/core'
import styles from '../../styles/admin/CenterCard.module.scss'
import { PayPalScriptProvider } from '@paypal/react-paypal-js'
import PayPalCheckout from '../../utils/PayPalCheckout'

const UploadsBox = () => {
  const user = useAuthStore((state) => state.user)
  const dataType = [
    { value: '', label: 'All' },
    { value: 'M', label: 'Manual' },
    { value: 'S', label: 'Lesson Material' },
    { value: 'E', label: 'Others' },
  ]
  const dataState = [
    { value: 'Y', label: 'Active' },
    { value: 'N', label: 'Inactive' },
  ]
  const dataStep = [
    { value: '', label: 'All' },
    { value: 'A', label: 'Preschool' },
    { value: 'B', label: 'Afterschool' },
  ]
  const dataStep2 = [
    { value: 'A', label: 'Preschool' },
    { value: 'B', label: 'Afterschool' },
  ]
  const [isManualModalOpen, setIsManualModalOpen] = useState(false)
  const [isPurchaseModalOpen, setIsPurchaseModalOpen] = useState(false)
  const [isManualCardModalOpen, setIsManualCardModalOpen] = useState(false)
  const [type, setType] = useState('')
  const [TITLE, setTITLE] = useState('')
  const [step, setStep] = useState('')
  const [publisher, setPublisher] = useState('')
  const [isBookModalOpen, setIsBookModalOpen] = useState(false)
  const [manualForm, setManualForm] = useState({
    title: '',
    type: '',
    state: 'Y',
    step: 'A',
    desc: '',
    price: 0,
  })
  const [selectedBookForPurchase, setSelectedBookForPurchase] = useState(null)
  const [pdfFile, setPdfFile] = useState(null)
  const [bookForm, setBookForm] = useState({
    title: '',
    publisher: '',
    price: '',
    state: 'Y',
    desc: '',
    image: null,
  })
  const [purchaseForm, setPurchaseForm] = useState({
    selectedBook: '',
    bookId: '',
    price: '',
    quantity: '',
    totalPrice: '$0',
  })
  const [manualData, setManualData] = useState([])
  const [manualData2, setManualData2] = useState([])
  const [manualCardList, setManualCardList] = useState([])
  const [selectedManual, setSelectedManual] = useState(null)
  const [isEditMode, setIsEditMode] = useState(false)
  const [isEditingBook, setIsEditingBook] = useState(false)
  const [adminCurrentPage, setAdminCurrentPage] = useState(1)
  const [adminItemsPerPage, setAdminItemsPerPage] = useState(10)
  const [bookCurrentPage, setBookCurrentPage] = useState(1)
  const [bookItemsPerPage, setBookItemsPerPage] = useState(10)
  const [manualsToPurchase, setManualsToPurchase] = useState([])
  //const [purchasedKeys, setPurchasedKeys] = useState([])
  const [purchasedKeys, setPurchasedKeys] = useState(new Set())
  const [showPayPal, setShowPayPal] = useState(false)
  const [showPayPal3, setShowPayPal3] = useState(false)
  const [showPayPal4, setShowPayPal4] = useState(false)
  const [manualPrice, setManualPrice] = useState(0)
  const [manualTotalPrice, setManualTotalPrice] = useState(0)

  useEffect(() => {
    ;(async () => {
      const centerId = user?.CENTER_ID
      if (centerId) {
        const keys = await fetchHaveManual(centerId)
        await fetchUploadList(keys) // 즉시 반영되므로 첫 화면에서 바로 View 표시
      } else {
        await fetchUploadList()
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.CENTER_ID])

  const getManualHeaders = () => {
    if (user?.STATUS === 'A') {
      return [
        'Order',
        'Title',
        'Type',
        'View',
        'Program Type',
        'Date Created',
        'Details',
        'delete',
      ]
    } else if (user?.STATUS === 'M') {
      return [
        'Order',
        'Title',
        'Type',
        'View',
        'Program Type',
        'Date Created',
        'Purchase',
      ]
    } else {
      return ['Order', 'Title', 'Type', 'View', 'Program Type', 'Date Created']
    }
  }
  const getManualColumnWidths = () => {
    if (user?.STATUS === 'A') {
      return ['5%', '45%', '10%', '10%', '10%', '10%', '5%', '5%']
    } else if (user?.STATUS === 'M') {
      return ['5%', '45%', '10%', '10%', '10%', '10%', '10%']
    } else {
      return ['5%', '55%', '10%', '10%', '10%', '10%']
    }
  }

  const fetchHaveManual = async () => {
    try {
      const res = await apiRequest('/fetchHaveManual', 'POST', {
        ID: user.CENTER_ID,
      })
      if (res.success) {
        const keysArr = res.data.map((item) => `${item.ITEM_CD}${item.TITLE}`)
        const keys = new Set(keysArr)
        setPurchasedKeys(keys)
        return keys
      }
    } catch (err) {
      console.error('Search Error:', err)
      notifications.show({
        title: 'Error',
        message: 'An error occurred while retrieving purchase history.',
        color: 'red',
      })
    }
  }

  const fetchUploadList = async (keysParam) => {
    try {
      const res = await apiRequest('/getUploadList', 'POST', {
        type,
        TITLE,
        step,
      })
      if (res.data) {
        const keys = keysParam || purchasedKeys

        const filteredData = res.data.map((upload, index) => {
          const canView =
            user?.STATUS === 'A' || keys.has(`${upload.STEP}${upload.TITLE}`)

          const baseData = {
            NO: index + 1,
            TITLE: (
              <div
                className="list-cell-content"
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  width: '100%',
                }}
              >
                {upload.TITLE}
              </div>
            ),
            TYPE: upload.DATA_TYPE,
            VIEW: canView ? (
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault()
                  window.open(
                    upload.FILE_URL,
                    '_blank',
                    'width=800,height=600,scrollbars=yes,resizable=yes'
                  )
                }}
              >
                View
              </a>
            ) : (
              <span style={{ color: '#ccc' }}>Not Purchased</span>
            ),
            GRADE: dataStep2.find((item) => item.value === upload.STEP)?.label,
            REG_DTM: upload.REG_DTM,
          }

          // 어드민인 경우에만 삭제 버튼
          if (user?.STATUS === 'A') {
            return {
              ...baseData,
              DETAIL: (
                <button
                  style={{
                    cursor: 'pointer',
                    color: 'blue',
                    textDecoration: 'underline',
                    background: 'none',
                    border: 'none',
                  }}
                  onClick={() => {
                    setSelectedManual(upload)
                    setManualForm({
                      title: upload.TITLE,
                      type: upload.TYPE,
                      desc: upload.DESCRIPTION || '',
                      state: upload.STATE,
                      step: upload.STEP,
                      price: upload.PRICE,
                    })
                    setPdfFile(null)
                    setIsEditMode(true)
                    setIsManualModalOpen(true)
                  }}
                >
                  Details
                </button>
              ),
              DELETE: (
                <button
                  style={{
                    cursor: 'pointer',
                    color: 'red',
                    background: 'none',
                    border: 'none',
                  }}
                  onClick={() => handleManualDelete(upload.ID)}
                >
                  Delete
                </button>
              ),
            }
          }

          // 매니저인 경우 구매 버튼 추가
          if (user?.STATUS === 'M') {
            return {
              ...baseData,
              PURCHASE: (
                <button
                  style={{
                    cursor: 'pointer',
                    color: 'white',
                    backgroundColor: '#007bff',
                    border: 'none',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '12px',
                  }}
                  onClick={() => handleSingleManualPurchase(upload)}
                >
                  Purchase
                </button>
              ),
            }
          }

          return baseData
        })
        setManualData(filteredData)
      }
    } catch (err) {
      console.error('Failed to fetch uploaded data:', err)
      notifications.show({
        title: 'Error',
        message: 'Failed to load uploaded data.',
        color: 'red',
      })
    }
  }

  const handleManualDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this?')) return
    try {
      const res = await apiRequest('/deleteManual', 'POST', { id })
      if (res.success) {
        notifications.show({
          title: 'Deleted successfully.',
          message: 'Deleted.',
          color: 'green',
        })
        fetchUploadList() // 목록 새로고침
      } else {
        throw new Error('Failed to delete.')
      }
    } catch (err) {
      console.error('삭제 오류:', err)
      notifications.show({
        title: 'Error',
        message: 'An error occurred while deleting.',
        color: 'red',
      })
    }
  }

  const handleManualUpdate = async (id) => {
    try {
      let fileUrl = selectedManual.FILE_URL // 기존 파일 URL
      let fileName = selectedManual.FILE_NAME || ''

      // 새 파일이 선택된 경우 업로드
      if (pdfFile) {
        const formData = new FormData()
        formData.append('file', pdfFile)
        const uploadRes = await uploadRequest('/upload-pdf', formData)

        if (uploadRes.success) {
          fileUrl = uploadRes.fileUrl
          fileName = pdfFile.name
        } else {
          throw new Error('Failed to upload PDF')
        }
      }

      const res = await apiRequest('/updateManual', 'POST', {
        id,
        title: manualForm.title,
        type: manualForm.type,
        desc: manualForm.desc,
        state: manualForm.state,
        step: manualForm.step,
        price: manualForm.price,
        fileUrl,
        fileName,
      })

      if (res.success) {
        notifications.show({
          title: 'Update successful',
          message: 'Manual information has been updated.',
          color: 'green',
        })
        await fetchUploadList()
        handleManualModalClose()
      } else {
        throw new Error('Failed to update')
      }
    } catch (err) {
      console.error('Failed to update:', err)
      notifications.show({
        title: 'Error',
        message: 'An error occurred while updating',
        color: 'red',
      })
    }
  }

  const fetchUploadList2 = async () => {
    try {
      const res = await apiRequest('/getUploadList2', 'POST', {
        type,
        TITLE,
        publisher,
      })
      if (res.data) {
        setManualData2(res.data)
      }
    } catch (err) {
      console.error('Failed to fetch uploaded data:', err)
      notifications.show({
        title: 'Error',
        message: 'Failed to load uploaded data.',
        color: 'red',
      })
    }
  }

  const handleAdminPageChange = (page) => {
    setAdminCurrentPage(page)
  }

  const handleAdminItemsPerPageChange = (value) => {
    const numValue = parseInt(value.replace('entries', ''))
    setAdminItemsPerPage(numValue)
    setAdminCurrentPage(1)
  }

  const handleManagerPageChange = (page) => {
    setManagerCurrentPage(page)
  }

  const handleManagerItemsPerPageChange = (value) => {
    const numValue = parseInt(value.replace('entries', ''))
    setManagerItemsPerPage(numValue)
    setManagerCurrentPage(1)
  }

  const handleBookPageChange = (page) => setBookCurrentPage(page)

  const handleBookItemsPerPageChange = (value) => {
    const numValue = parseInt(value.replace('entries', ''))
    setBookItemsPerPage(numValue)
    setBookCurrentPage(1)
  }

  const getAdminCurrentPageData = () => {
    const data = manualData || []
    const startIndex = (adminCurrentPage - 1) * adminItemsPerPage
    const endIndex = startIndex + adminItemsPerPage
    return data.slice(startIndex, endIndex)
  }

  const getAdminTotalPages = () => {
    return Math.ceil((manualData?.length || 0) / adminItemsPerPage)
  }

  const getManagerCurrentPageData = () => {
    const data = manualManagerData || []
    const startIndex = (managerCurrentPage - 1) * managerItemsPerPage
    const endIndex = startIndex + managerItemsPerPage
    return data.slice(startIndex, endIndex)
  }

  const getManagerTotalPages = () => {
    return Math.ceil((manualManagerData?.length || 0) / managerItemsPerPage)
  }

  const getBookCurrentPageData = () => {
    const data = manualData2 || []
    const startIndex = (bookCurrentPage - 1) * bookItemsPerPage
    const endIndex = startIndex + bookItemsPerPage
    return data.slice(startIndex, endIndex)
  }

  const getBookTotalPages = () => {
    return Math.ceil((manualData2?.length || 0) / bookItemsPerPage)
  }

  const handleManualModalOpen = () => {
    setIsManualModalOpen(true)
  }

  const handleBookModalOpen = () => {
    setIsBookModalOpen(true)
  }

  const handleManualModalClose = () => {
    setIsManualModalOpen(false)
    setManualForm({ title: '', type: '', state: 'Y', desc: '', step: '' })
    setIsEditMode(false)
  }

  const handleBookModalClose = () => {
    setIsBookModalOpen(false)
    setIsEditingBook(false)
    setBookForm({
      title: '',
      publisher: '',
      price: '',
      image: null,
      state: 'Y',
      desc: '',
    })
  }

  const handlePurchaseFormChange = (field, value) => {
    setPurchaseForm((prev) => {
      const updated = {
        ...prev,
        [field]: value,
      }

      if (field === 'price' || field === 'quantity') {
        const price = parseFloat(updated.price) || 0
        const quantity = parseFloat(updated.quantity) || 0
        const total = price * quantity
        updated.totalPrice = `$${total.toLocaleString()}`
      }

      return updated
    })
  }

  const handleBookSelection = (selectedBookId) => {
    const selectedBook = manualData2.find((book) => book.ID === selectedBookId)
    if (selectedBook) {
      const bookPrice = parseFloat(selectedBook.PRICE) || 0
      const currentQuantity = parseFloat(purchaseForm.quantity || 0)
      const total = bookPrice * currentQuantity

      setPurchaseForm((prev) => ({
        ...prev,
        selectedBook: selectedBookId,
        price: selectedBook.PRICE,
        totalPrice: `$${total.toLocaleString()}`,
      }))
    }
  }

  const handleManualFormChange = (field, value) => {
    setManualForm((prev) => ({
      ...prev,
      [field]: value,
    }))
  }

  const handleBookFormChange = (field, value) => {
    setBookForm((prev) => ({
      ...prev,
      [field]: value,
    }))
  }

  const handleManualCardModalOpen = (type) => {
    handleManualCardList(type)
    setIsManualCardModalOpen(true)
  }

  const handleManualCardModalClose = () => {
    setIsManualCardModalOpen(false)
  }

  const handleManualCardList = async (type) => {
    try {
      const res = await apiRequest('/getManualCardList', 'POST', { type })
      if (res.data) {
        setManualCardList(res.data)
      }
    } catch (err) {
      console.error('Failed to fetch package data:', err)
      notifications.show({
        title: 'Error',
        message: 'Failed to load package data',
        color: 'red',
      })
    }
  }

  const handleManualSave = async () => {
    try {
      let fileUrl = ''
      let fileName = ''

      if (pdfFile) {
        const formData = new FormData()
        formData.append('file', pdfFile)
        for (let [key, value] of formData.entries()) {
        }
        const uploadRes = await uploadRequest('/upload-pdf', formData)

        if (uploadRes.success) {
          fileUrl = uploadRes.fileUrl
          fileName = pdfFile.name
        } else {
          throw new Error('Failed to upload PDF')
        }
      }

      // 매뉴얼 저장 요청
      const saveRes = await apiRequest('/uploadManual', 'POST', {
        title: manualForm.title,
        type: manualForm.type,
        desc: manualForm.desc,
        state: manualForm.state,
        step: manualForm.step,
        price: manualForm.price,
        fileUrl,
        fileName,
      })

      if (saveRes.success) {
        notifications.show({
          title: 'Success',
          message: 'Saved successfully.',
          color: 'green',
        })
        await fetchUploadList() // 목록 새로고침
        handleManualModalClose()
      } else {
        throw new Error('Failed to save manual.')
      }
    } catch (err) {
      console.error('Failed to save manual.:', err)
      notifications.show({
        title: 'Error',
        message: 'Failed to save.',
        color: 'red',
      })
    }
  }

  const handleBookSave = async () => {
    try {
      let imageUrl = ''

      if (bookForm.image) {
        try {
          imageUrl = await uploadBookImage(bookForm.image)
        } catch (err) {
          console.error(err)
          notifications.show({
            title: 'Error',
            message: 'Failed to upload image',
            color: 'red',
          })
          return
        }
      }

      const saveRes = await apiRequest('/saveUploads2', 'POST', {
        ...bookForm,
        IMAGE_URL: imageUrl,
      })

      if (saveRes.success) {
        notifications.show({
          title: 'Upload successful',
          message: 'Lesson material uploaded successfully.',
          color: 'green',
        })
        await fetchUploadList2()
      }
    } catch (err) {
      console.error('Failed to save lesson material.:', err)
      notifications.show({
        title: 'Error',
        message: 'Failed to save.',
        color: 'red',
      })
    }

    handleBookModalClose()
  }

  const uploadBookImage = async (file) => {
    const formData = new FormData()
    formData.append('image', file)
    const baseUrl = process.env.REACT_APP_API_URL
    const res = await fetch(`${baseUrl}/img/upload`, {
      method: 'POST',
      body: formData,
    })

    const data = await res.json()

    if (!res.ok || !data.imageUrl) {
      throw new Error('Failed to upload image')
    }

    return data.imageUrl
  }

  const handleBookUpdate = async () => {
    try {
      let imageUrl = ''

      if (bookForm.image) {
        imageUrl = await uploadBookImage(bookForm.image)
      }

      const saveRes = await apiRequest('/updateUploads2', 'POST', {
        ...bookForm,
        IMAGE_URL: imageUrl, // 새 이미지 있으면 업데이트
      })

      if (saveRes.success) {
        notifications.show({
          title: 'Update successful',
          message: 'Lesson material has been updated.',
          color: 'green',
        })
        await fetchUploadList2()
        handleBookModalClose()
      } else {
        throw new Error('Failed to update')
      }
    } catch (err) {
      console.error('교재 Failed to update:', err)
      notifications.show({
        title: 'Error',
        message: 'Failed to update',
        color: 'red',
      })
    }
  }

  const handlePurchaseModalOpen = (book) => {
    setSelectedBookForPurchase(book)
    setPurchaseForm({
      selectedBook: book.ID,
      bookId: book.publisher || '',
      price: book.PRICE,
      quantity: '',
      totalPrice: '$0',
    })
    setIsPurchaseModalOpen(true)
  }

  const handlePurchaseModalClose = () => {
    setIsPurchaseModalOpen(false)
    setPurchaseForm({
      selectedBook: '',
      bookId: '',
      price: '',
      quantity: '',
      totalPrice: '$0',
    })
  }

  const handlePurchase = () => {
    modals.openConfirmModal({
      title: 'Purchase Confirmation',
      children: (
        <div>
          <p>Would you like to purchase the following teaching tool?</p>
          <div
            style={{
              backgroundColor: '#f9f9f9',
              padding: '12px',
              borderRadius: '8px',
              margin: '12px 0',
              fontSize: '14px',
            }}
          >
            <div>
              <strong>Title:</strong> {selectedBookForPurchase?.TITLE}
            </div>
            <div>
              <strong>Quantity:</strong> {purchaseForm.quantity}entries
            </div>
            <div>
              <strong>Total Price:</strong>$ {purchaseForm.totalPrice}
            </div>
          </div>
          <p style={{ color: '#666', fontSize: '14px' }}>
            Once purchased, this item cannot be canceled. Please decide
            carefully.
          </p>
        </div>
      ),
      labels: { confirm: 'Buy Now', cancel: 'Cancel' },
      confirmProps: { color: 'blue' },
      onCancel: () => {},
      onConfirm: async () => {
        setShowPayPal(true)
      },
    })
  }

  const saveOrderToDB = async () => {
    try {
      const res = await apiRequest('/addOrder', 'POST', {
        item_code: selectedBookForPurchase?.publisher || '',
        title: selectedBookForPurchase?.TITLE || '',
        quantity: purchaseForm.quantity,
        total_price: Number(purchaseForm.totalPrice.replace(/\$|,/g, '')),
        buyer_name: user?.USER_ID || 'Guest',
        center_name: user?.CENTER_ID || 'Unknown',
        type: 'B',
      })
      if (res.success) {
        notifications.show({
          title: 'Purchase completed.',
          message: `Your purchase has been completed..`,
          color: 'green',
        })
        handlePurchaseModalClose()
      }
    } catch (err) {
      console.error('Failed to save order.', err)
      notifications.show({
        title: 'Error',
        message: 'There was a problem processing your purchase.',
        color: 'red',
      })
    }
  }

  const handleSingleManualPurchase = (upload) => {
    modals.openConfirmModal({
      title: 'Purchase Confirmation',
      children: (
        <div>
          <p>Would you like to purchase the following item?</p>
          <div
            style={{
              backgroundColor: '#f9f9f9',
              padding: '12px',
              borderRadius: '8px',
              margin: '12px 0',
            }}
          >
            <div>
              <strong>Title:</strong> {upload.TITLE}
            </div>
            <div>
              <strong>Type:</strong> {upload.DATA_TYPE}
            </div>
            <div>
              <strong>Price:</strong>${upload.PRICE}
            </div>
          </div>
        </div>
      ),
      labels: { confirm: 'Buy Now', cancel: 'Cancel' },
      confirmProps: { color: 'blue' },
      onConfirm: async () => {
        setManualPrice(upload.PRICE)
        setShowPayPal3(true)
      },
    })
  }

  const handlePackagePurchase = (packageData) => {
    const totalPrice = packageData[0]?.STEP === 'A' ? 3000 : 3000

    modals.openConfirmModal({
      title: 'Purchase Confirmation',
      children: (
        <div>
          <p>Would you like to purchase the following item?</p>
          <div
            style={{
              backgroundColor: '#f9f9f9',
              padding: '12px',
              borderRadius: '8px',
              margin: '12px 0',
            }}
          >
            <div>
              <strong>Title:</strong>{' '}
              {packageData[0]?.STEP === 'A'
                ? 'Preschool Package'
                : 'Afterschool Package'}
            </div>
            <div>
              <strong>Type:</strong> Package
            </div>
            <div>
              <strong>Total Price:</strong> ${totalPrice}
            </div>
          </div>
        </div>
      ),
      labels: { confirm: 'Buy Now', cancel: 'Cancel' },
      confirmProps: { color: 'blue' },
      onConfirm: async () => {
        setManualTotalPrice(totalPrice)
        setShowPayPal4(true)
      },
    })
  }

  const saveSingleManualOrder = async (upload) => {
    try {
      await apiRequest('/addOrder2', 'POST', {
        item_code: upload.ID || '',
        title: upload.TITLE,
        quantity: 1,
        total_price: upload.PRICE || 0,
        buyer_name: user?.USER_ID || 'Guest',
        center_name: user?.CENTER_ID || 'Unknown',
        type: 'M',
      })

      notifications.show({
        title: 'Purchase completed.',
        message: 'Your purchase has been completed..',
        color: 'green',
      })
    } catch (err) {
      console.error('Failed to save order.', err)
      notifications.show({
        title: 'Error',
        message: 'There was a problem processing your purchase.',
        color: 'red',
      })
    }
  }

  const saveSingleManualOrder2 = async (upload) => {
    try {
      await apiRequest('/addOrder3', 'POST', {
        item_code: upload.ID || '',
        title: upload.TITLE,
        quantity: 1,
        total_price: upload.PRICE || 0,
        buyer_name: user?.USER_ID || 'Guest',
        center_name: user?.CENTER_ID || 'Unknown',
        type: 'M',
      })

      notifications.show({
        title: 'Purchase completed.',
        message: 'Your purchase has been completed..',
        color: 'green',
      })
    } catch (err) {
      console.error('Failed to save order.', err)
      notifications.show({
        title: 'Error',
        message: 'There was a problem processing your purchase.',
        color: 'red',
      })
    }
  }
  return (
    <div>
      <Tabs color="blue" defaultValue="manual">
        <Tabs.List>
          <Tabs.Tab
            value="manual"
            style={{ width: '50%' }}
            onClick={() => {
              setTITLE('')
              setStep('')
              setType('')
              fetchUploadList()
            }}
          >
            Manuals and Lesson Materials
          </Tabs.Tab>
          <Tabs.Tab
            value="bookInfo"
            style={{ width: '50%' }}
            onClick={() => {
              setTITLE('')
              setPublisher('')
              setType('')
              fetchUploadList2()
            }}
          >
            Teaching Tool Sales Information
          </Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="manual" pt="lg">
          {/* 어드민일때 보여지는 매뉴얼 */}
          {user?.STATUS === 'A' && (
            <>
              <div className="uploads-search-section">
                <div className="search-section">
                  <input
                    className="search-input"
                    placeholder="Title"
                    value={TITLE}
                    onChange={(e) => setTITLE(e.target.value)}
                  />
                  <label>Material Type :</label>
                  <MantineSelectBox
                    value={type}
                    data={dataType}
                    onChange={setType}
                    width="200px"
                  />
                  <label>Program Type :</label>
                  <MantineSelectBox
                    value={step}
                    data={dataStep}
                    onChange={setStep}
                    width="200px"
                  />
                </div>
                <div className="search-buttons">
                  <SaveButton
                    className="update-button"
                    onClick={() => {
                      setTITLE('')
                      setStep('')
                      setType('')
                    }}
                  >
                    Reset
                  </SaveButton>
                  <SaveButton onClick={fetchUploadList}>Search</SaveButton>
                </div>
              </div>

              <div className="add-button-wrapper">
                <BaseButton
                  className="add-button"
                  onClick={handleManualModalOpen}
                >
                  Add
                </BaseButton>
              </div>

              <List
                showCheckbox={false}
                headers={getManualHeaders()}
                data={getAdminCurrentPageData()}
                columnWidths={getManualColumnWidths()}
              />

              <div className={styles.paginationWrapper}>
                <Pagination
                  value={adminCurrentPage}
                  onChange={handleAdminPageChange}
                  total={getAdminTotalPages()}
                  size="sm"
                  withEdges={false}
                  color="gray"
                  classNames={{
                    control: styles.paginationControl,
                  }}
                />
              </div>

              <div className="users-select-wrapper">
                <Select
                  styles={{ input: { width: '150px', height: '30px' } }}
                  data={['10entries', '20entries', '50entries']}
                  value={`${adminItemsPerPage}entries`}
                  onChange={handleAdminItemsPerPageChange}
                />
              </div>
            </>
          )}

          {/* 매니저일때 보여지는 매뉴얼 */}
          {user?.STATUS === 'M' && (
            <>
              <div className="uploads-search-section">
                <div className="search-section">
                  <input
                    className="search-input"
                    placeholder="Title"
                    value={TITLE}
                    onChange={(e) => setTITLE(e.target.value)}
                  />
                  <label>Material Type :</label>
                  <MantineSelectBox
                    value={type}
                    data={dataType}
                    onChange={setType}
                    width="200px"
                  />
                  <label>Program Type :</label>
                  <MantineSelectBox
                    value={step}
                    data={dataStep}
                    onChange={setStep}
                    width="200px"
                  />
                </div>
                <div className="search-buttons">
                  <SaveButton
                    className="update-button"
                    onClick={() => {
                      setTITLE('')
                      setStep('')
                      setType('')
                    }}
                  >
                    Reset
                  </SaveButton>
                  <SaveButton onClick={fetchUploadList}>Search</SaveButton>
                </div>
              </div>
              <div className="manual-cards-container">
                <ManualCard
                  title="Preschool"
                  onClick={() => handleManualCardModalOpen('A')}
                />
                <ManualCard
                  title="Afterschool"
                  onClick={() => handleManualCardModalOpen('B')}
                />
              </div>

              <List
                showCheckbox={false}
                headers={getManualHeaders()}
                data={getAdminCurrentPageData()}
                columnWidths={getManualColumnWidths()}
              />

              <div className={styles.paginationWrapper}>
                <Pagination
                  value={adminCurrentPage}
                  onChange={handleAdminPageChange}
                  total={getAdminTotalPages()}
                  size="sm"
                  withEdges={false}
                  color="gray"
                  classNames={{
                    control: styles.paginationControl,
                  }}
                />
              </div>
              <div className="users-select-wrapper">
                <Select
                  styles={{ input: { width: '150px', height: '30px' } }}
                  data={['10entries', '20entries', '50entries']}
                  value={`${adminItemsPerPage}entries`}
                  onChange={handleAdminItemsPerPageChange}
                />
              </div>
            </>
          )}

          {/* 선생님 일때 보여지는 매뉴얼 */}
          {user?.STATUS === 'T' && (
            <>
              <div className="uploads-search-section">
                <div className="search-section">
                  <input
                    className="search-input"
                    placeholder="Title"
                    value={TITLE}
                    onChange={(e) => setTITLE(e.target.value)}
                  />
                  <label>Material Type :</label>
                  <MantineSelectBox
                    value={type}
                    data={dataType}
                    onChange={setType}
                    width="200px"
                  />
                  <label>Program Type :</label>
                  <MantineSelectBox
                    value={step}
                    data={dataStep}
                    onChange={setStep}
                    width="200px"
                  />
                </div>
                <div className="search-buttons">
                  <SaveButton
                    className="update-button"
                    onClick={() => {
                      setTITLE('')
                      setStep('')
                      setType('')
                    }}
                  >
                    Reset
                  </SaveButton>
                  <SaveButton onClick={fetchUploadList}>Search</SaveButton>
                </div>
              </div>

              <List
                showCheckbox={false}
                headers={getManualHeaders()}
                data={getAdminCurrentPageData()}
                columnWidths={getManualColumnWidths()}
              />

              <div className={styles.paginationWrapper}>
                <Pagination
                  value={adminCurrentPage}
                  onChange={handleAdminPageChange}
                  total={getAdminTotalPages()}
                  size="sm"
                  withEdges={false}
                  color="gray"
                  classNames={{
                    control: styles.paginationControl,
                  }}
                />
              </div>
              <div className="users-select-wrapper">
                <Select
                  styles={{ input: { width: '150px', height: '30px' } }}
                  data={['10entries', '20entries', '50entries']}
                  value={`${adminItemsPerPage}entries`}
                  onChange={handleAdminItemsPerPageChange}
                />
              </div>
            </>
          )}
        </Tabs.Panel>

        <Tabs.Panel value="bookInfo" pt="lg">
          <div className="uploads-search-section">
            <div className="search-section">
              <input
                className="search-input"
                placeholder="Title"
                value={TITLE}
                onChange={(e) => setTITLE(e.target.value)}
              />
              <input
                className="search-input"
                placeholder="Teaching Tool Serial Number"
                value={publisher}
                onChange={(e) => setPublisher(e.target.value)}
              />
            </div>
            <div className="search-buttons">
              <SaveButton
                className="update-button"
                onClick={() => {
                  setTITLE('')
                  setPublisher('')
                }}
              >
                Reset
              </SaveButton>
              <SaveButton className="update-button" onClick={fetchUploadList2}>
                Search
              </SaveButton>
            </div>
          </div>

          {user?.STATUS === 'A' && (
            <div className="add-button-wrapper">
              <BaseButton className="add-button" onClick={handleBookModalOpen}>
                Add
              </BaseButton>
            </div>
          )}

          <div className="book-cards-container">
            {getBookCurrentPageData().map((book, index) => (
              <BookInfoCard
                key={index}
                image={<img src={book.FILE_URL} alt={'img'} />}
                title={
                  <span
                    style={{
                      cursor: 'pointer',
                      textDecoration: 'underline',
                      color: 'blue',
                    }}
                    onClick={() => {
                      setBookForm({
                        title: book.TITLE,
                        publisher: book.publisher || '',
                        price: book.PRICE,
                        state: book.STATE,
                        desc: book.DESCRIPTION || '',
                        image: null,
                        id: book.ID,
                      })
                      setIsBookModalOpen(true)
                      setIsEditingBook(true)
                    }}
                  >
                    {book.TITLE}
                  </span>
                }
                publisher={book.publisher || ''}
                price={`${Number(book.PRICE).toLocaleString()}$`}
                purchase={
                  user?.STATUS === 'M'
                    ? () => handlePurchaseModalOpen(book)
                    : null
                }
                actions={
                  user?.STATUS === 'A' ? (
                    <div
                      onClick={async () => {
                        if (
                          window.confirm(
                            'Are you sure you want to delete this?'
                          )
                        ) {
                          const res = await apiRequest(
                            '/deleteUploads2',
                            'POST',
                            { id: book.ID }
                          )
                          if (res.success) {
                            notifications.show({
                              title: 'Delete',
                              message: 'Deleted.',
                              color: 'green',
                            })
                            fetchUploadList2()
                          } else {
                            notifications.show({
                              title: 'Error',
                              message: 'Failed to delete.',
                              color: 'red',
                            })
                          }
                        }
                      }}
                    >
                      Delete
                    </div>
                  ) : null
                }
              />
            ))}
          </div>

          <div className={styles.paginationWrapper}>
            <Pagination
              value={bookCurrentPage}
              onChange={handleBookPageChange}
              total={getBookTotalPages()}
              size="sm"
              withEdges={false}
              color="gray"
              classNames={{
                control: styles.paginationControl,
              }}
            />
          </div>

          <div className="users-select-wrapper">
            <Select
              styles={{ input: { width: '150px', height: '30px' } }}
              data={['10entries', '20entries', '50entries']}
              value={`${bookItemsPerPage}entries`}
              onChange={handleBookItemsPerPageChange}
            />
          </div>
        </Tabs.Panel>
      </Tabs>

      {/* 매뉴얼 및 수업자료 추가 모달 */}
      <Modal
        opened={isManualModalOpen}
        onClose={handleManualModalClose}
        title="Add Manuals and Lesson Materials"
        size="md"
      >
        <div className="modal-content">
          <div className="form-group">
            <label>Type</label>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignContent: 'center',
                gap: '10px',
              }}
            >
              <MantineSelectBox
                value={manualForm.type}
                onChange={(value) => handleManualFormChange('type', value)}
                data={dataType}
                placeholder="Type"
                width="50%"
              />
              <MantineSelectBox
                value={manualForm.state}
                onChange={(value) => handleManualFormChange('state', value)}
                data={dataState}
                placeholder="Status"
                width="50%"
              />
            </div>

            <label>Price</label>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignContent: 'center',
                gap: '10px',
              }}
            >
              <div style={{ position: 'relative' }}>
                <span
                  style={{
                    position: 'absolute',
                    left: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: '#666',
                    zIndex: 1,
                    pointerEvents: 'none',
                  }}
                >
                  $
                </span>
                <input
                  type="number"
                  value={manualForm.price}
                  onChange={(e) =>
                    handleManualFormChange('price', e.target.value)
                  }
                  placeholder="Price"
                  style={{
                    paddingLeft: '25px',
                    width: '100%',
                  }}
                  disabled={user?.STATUS === 'M'}
                />
              </div>
              <MantineSelectBox
                value={manualForm.step}
                onChange={(value) => handleManualFormChange('step', value)}
                data={dataStep2}
                placeholder="Step"
                width="50%"
              />
            </div>
            <label>Title</label>
            <input
              type="text"
              value={manualForm.title}
              onChange={(e) => handleManualFormChange('title', e.target.value)}
              placeholder="Title"
            />

            <label>Description</label>
            <textarea
              value={manualForm.desc}
              onChange={(e) => handleManualFormChange('desc', e.target.value)}
              placeholder=""
              rows={5}
              style={{ width: '100%', padding: '10px' }}
            />
          </div>

          <PdfDropzone
            pdfFile={pdfFile}
            onPdfChange={setPdfFile}
            label="Lesson Material PDF"
            showLabel={true}
            placeholderText="Drag or click to upload a PDF file"
          />

          <div className="button-wrapper">
            <SaveButton onClick={handleManualModalClose}>Cancel</SaveButton>
            {isEditMode ? (
              <SaveButton
                onClick={() => handleManualUpdate(selectedManual?.ID)}
              >
                Update
              </SaveButton>
            ) : (
              <SaveButton onClick={handleManualSave}>Submit</SaveButton>
            )}
          </div>
        </div>
      </Modal>

      {/* 교재 추가 모달 */}
      <Modal
        opened={isBookModalOpen}
        onClose={handleBookModalClose}
        title="Teaching Tool Sales Information"
        size="md"
      >
        <div className="modal-content">
          <div className="form-group">
            <label>Teaching Tool Serial Number</label>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignContent: 'center',
                gap: '10px',
              }}
            >
              <input
                type="text"
                value={bookForm.publisher}
                onChange={(e) =>
                  handleBookFormChange('publisher', e.target.value)
                }
                placeholder="Book Number"
                style={{ width: '50%' }}
                disabled={user?.STATUS === 'M'}
              />
              <MantineSelectBox
                value={bookForm.state}
                onChange={(value) => handleManualFormChange('state', value)}
                data={dataState}
                placeholder="Status"
                width="50%"
                disabled={user?.STATUS === 'M'}
              />
            </div>
            <label>Title</label>
            <input
              type="text"
              value={bookForm.title}
              onChange={(e) => handleBookFormChange('title', e.target.value)}
              placeholder="Title"
              disabled={user?.STATUS === 'M'}
            />

            <label>Price</label>
            <div
              style={{
                position: 'relative',
                display: 'inline-block',
                width: '100%',
              }}
            >
              <span
                style={{
                  position: 'absolute',
                  left: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: '#666',
                  zIndex: 1,
                  pointerEvents: 'none',
                }}
              >
                $
              </span>
              <input
                type="number"
                value={bookForm.price}
                onChange={(e) => handleBookFormChange('price', e.target.value)}
                placeholder="Price"
                style={{
                  paddingLeft: '25px',
                  width: '100%',
                }}
                disabled={user?.STATUS === 'M'}
              />
            </div>

            <label>Description</label>
            <textarea
              value={bookForm.desc}
              onChange={(e) => handleBookFormChange('desc', e.target.value)}
              placeholder=""
              rows={5}
              style={{ width: '100%', padding: '10px' }}
              disabled={user?.STATUS === 'M'}
            />
          </div>

          {user?.STATUS === 'A' ? (
            <ImageDropzone
              imageFile={bookForm.image}
              onImageChange={(file) => handleBookFormChange('image', file)}
              label="Book Image"
              showLabel={true}
              placeholderText="Drag or click to upload a PDF file"
            />
          ) : null}

          <div className="button-wrapper">
            <SaveButton onClick={handleBookModalClose}>Cancel</SaveButton>
            {user?.STATUS === 'A' && (
              <SaveButton
                onClick={isEditingBook ? handleBookUpdate : handleBookSave}
              >
                {isEditingBook ? 'Update' : 'Submit'}
              </SaveButton>
            )}
          </div>
        </div>
      </Modal>

      {/* 매니저 카드 모달 */}
      <Modal
        opened={isManualCardModalOpen}
        onClose={handleManualCardModalClose}
        size="xl"
      >
        <div className="modal-content">
          <List
            showCheckbox={false}
            headers={['Order', 'Type', 'Title', 'Price', 'Date Created']}
            data={manualCardList.map((item, index) => ({
              NO: index + 1,
              DATA_TYPE: item.DATA_TYPE,
              TITLE: item.TITLE,
              PRICE: '$' + item.PRICE,
              REG_DTM: item.REG_DTM,
            }))}
            columnWidths={['10%', '20%', '50%', '10%', '20%']}
          />
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            {manualCardList[0]?.STEP === 'A' ? (
              <p>
                total Price: <del>$4500</del> <b>→ $3000</b>
              </p>
            ) : (
              <p>
                total Price: <del>$4000</del> <b>→ $3000</b>
              </p>
            )}
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <BaseButton
                className="card-purchase-button"
                // 패키지 구매 로직
                onClick={() => handlePackagePurchase(manualCardList)}
              >
                Purchase
              </BaseButton>
            </div>
          </div>
        </div>
      </Modal>

      {/* 매니저 책 구매 모달 */}
      <Modal
        opened={isPurchaseModalOpen}
        onClose={handlePurchaseModalClose}
        size="md"
      >
        <div className="modal-content">
          <div className="form-group">
            <label>Title</label>
            <input
              type="text"
              value={selectedBookForPurchase?.TITLE || ''}
              readOnly
              style={{ backgroundColor: '#f5f5f5' }}
            />

            <label>Teaching Tool Serial Number</label>
            <input
              type="text"
              value={selectedBookForPurchase?.publisher || ''}
              readOnly
              style={{ backgroundColor: '#f5f5f5' }}
            />

            <label>Price</label>
            <div
              style={{
                position: 'relative',
                display: 'inline-block',
                width: '100%',
              }}
            >
              <span style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#666', zIndex: 1, pointerEvents: 'none'}}>
                $
              </span>
              <input
                type="text"
                value={selectedBookForPurchase?.PRICE || ''}
                readOnly
                style={{ backgroundColor: '#f5f5f5', paddingLeft: '25px', width: '100%'}}
              />
            </div>

            <label>Quantity</label>
            <input
              type="number"
              value={purchaseForm.quantity}
              onChange={(e) =>
                handlePurchaseFormChange('quantity', e.target.value)
              }
              placeholder="Count"
            />

            <label>Total Price</label>
            <input
              type="text"
              value={purchaseForm.totalPrice}
              readOnly
              style={{ backgroundColor: '#f5f5f5' }}
            />
          </div>

          <div className="button-wrapper">
            <SaveButton onClick={handlePurchaseModalClose}>Cancel</SaveButton>
            <SaveButton onClick={handlePurchase}>Purchase</SaveButton>
          </div>
        </div>
      </Modal>

      {showPayPal && (
        <div style={{ zIndex: 9999, position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', }}>
          <div
            style={{
              backgroundColor: '#fff',
              borderRadius: '12px',
              width: '100%',
              maxWidth: '450px',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
              overflow: 'hidden',
            }}
          >
            <div
              style={{
                padding: '16px 24px',
                borderBottom: '1px solid #e0e0e0',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <h5 style={{ margin: 0 }}>PayPal</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                style={{ padding: '10px' }}
                onClick={() => setShowPayPal(false)}
              ></button>
            </div>
            <div
              style={{ padding: '20px', height: '500px', overflowY: 'auto' }}
            >
              <PayPalCheckout
                amount={String(
                  Number(purchaseForm.totalPrice.replace(/\$|,/g, '')).toFixed(
                    2
                  )
                )}
                onApprove={async () => {
                  await saveOrderToDB()
                  setShowPayPal(false)
                }}
                onCancel={() => console.log('[PAYPAL] user canceled')}
              />
            </div>
          </div>
        </div>
      )}
      {showPayPal3 && (
        <div
          style={{
            zIndex: 9999,
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              backgroundColor: '#fff',
              borderRadius: '12px',
              width: '100%',
              maxWidth: '450px',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
              overflow: 'hidden',
            }}
          >
            <div
              style={{
                padding: '16px 24px',
                borderBottom: '1px solid #e0e0e0',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <h5 style={{ margin: 0 }}>PayPal</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                style={{ padding: '10px' }}
                onClick={() => setShowPayPal3(false)}
              ></button>
            </div>
            <div
              style={{ padding: '20px', height: '500px', overflowY: 'auto' }}
            >
              <PayPalCheckout
                amount={String(
                  Number(manualPrice.totalPrice.replace(/\$|,/g, '')).toFixed(
                    2
                  )
                )}
                onApprove={async () => {
                  await saveSingleManualOrder()
                  setShowPayPal3(false)
                }}
                onCancel={() => console.log('[PAYPAL] user canceled')}
              />
            </div>
          </div>
        </div>
      )}
      {showPayPal4 && (
        <div
          style={{
            zIndex: 9999,
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              backgroundColor: '#fff',
              borderRadius: '12px',
              width: '100%',
              maxWidth: '450px',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
              overflow: 'hidden',
            }}
          >
            <div
              style={{
                padding: '16px 24px',
                borderBottom: '1px solid #e0e0e0',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <h5 style={{ margin: 0 }}>PayPal</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                style={{ padding: '10px' }}
                onClick={() => setShowPayPal4(false)}
              ></button>
            </div>
            <div
              style={{ padding: '20px', height: '500px', overflowY: 'auto' }}
            >
              <PayPalCheckout
                amount={String(
                  Number(manualTotalPrice.totalPrice.replace(/\$|,/g, '')).toFixed(
                    2
                  )
                )}
                onApprove={async () => {
                  await saveSingleManualOrder2()
                  setShowPayPal4(false)
                }}
                onCancel={() => console.log('[PAYPAL] user canceled')}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default UploadsBox
